import { AxiosResponse } from 'axios';
import qs from 'qs';

import { projectRequest } from 'api';

export interface IUserInfo {
  name: string | null;
  email: string;
}

interface IGetUserInfoArgs {
  ids: string[];
  isInternalRole?: boolean;
  supplier_id: string;
}

const getUserInfo = ({ ids = [], isInternalRole = false, supplier_id }: IGetUserInfoArgs) => {
  const url = isInternalRole ? 'dss-admin' : `dss-supplier.${supplier_id}`;
  return projectRequest(true, url).get(
    `/user-info?${qs.stringify({ ids: ids }, { indices: false })}`
  ) as unknown as AxiosResponse<Record<string, IUserInfo>>;
};

export default getUserInfo;